<template>
	<div class="col-12 col-md-6 col-lg-4 col-xl-4 mb-1 mb-md-2 mb-lg-2 mb-xl-2">
		<div class="blog-item">
			<!------------------ NEWS ITEM ARTICLE IMAGE ------------------->
			<div class="blog-post-image-container">
				<router-link
					class="blog-post-image"
					:to="{ 
						name: 'newsdetail', 
						query: { 
							id: newsItem.id, 
							newsPage, 
							query, 
							isRecentNews, 
						} 
					}"
				>
					<img
						:src="newsItem.article.largeImageURL? newsItem.article.largeImageURL : newsDefaultImage"
						:alt="newsItem.photoDescription"
						class="cover"
						@error="setDefaultImage($event)"
					/>
				</router-link>				
			</div>

			<!------------------ NEWS ITEM ARTICLE TITLE ------------------->
			<div class="blog-post-title-container d-flex flex-column">
				<div class="blog-post-title p-lg-3 p-xl-3">
					<div class="blog-title-text d-flex flex-column justify-content-center">
						<div class="limit-lines-2">
							{{ newsItem.article.title }}
						</div>
					</div>
				</div>
				<div class="blog-post-date blog-text p-lg-3 p-xl-3">
					{{ newsItem?.article?.date ? getFormattedDate(newsItem?.article?.date ) :  "" }}
				</div>
			</div>

			<!------------------ NEWS ITEM ARTICLE DESCRIPTION ------------------->
			<div class="blog-post-title-description d-flex flex-column justify-content-start mt-lg-3 mt-lx-3 px-lg-3 px-xl-3">
				<div class="blog-text limit-lines-3">
					{{ newsItem.article.headLine }}
				</div>
			</div>

			<!------------------ NEWS ITEM ARTICLE READ BUTTON ------------------->
			<div class="blog-post-read-details-action d-flex justify-content-center">
				<router-link
					:to="{ 
						name: 'newsdetail', 
						query: { 
							id: newsItem.id, 
							newsPage, 
							query, 
							isRecentNews, 
						} 
					}"
				>
					<v-btn
						rounded
						large
						dark
						:color="'#424EC4'"
						width="140"
						>
							Read
					</v-btn>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "NewsCard",
	props: {
		newsItem: {
			type: Object,
			required: true,
		},
		newsPage: Number,
		query: String,
		isRecentNews: Boolean,
	},
	data() {
		return {
			newsDefaultImage: require("../../assets/images/news/news-default.png"),
		};
	},
	methods: {
		setDefaultImage(event) {
			event.target.src = this.newsDefaultImage; // Replace the broken image with the default image
		},
		getFormattedDate(date) {
			const options = { year: "numeric", month: "short", day: "numeric" };
			
			return new Date(date).toLocaleDateString(undefined, options);
		},
	},
};
</script>

<style scoped>
.divider {
	border-radius: 3px !important;
	border: 1px solid rgba(0, 0, 0, 0.2) !important;
	background: rgba(217, 217, 217, 0) !important;
	position: relative;
	bottom: -33px;
	margin: 0px;
}
.blog-item {
	display: flex;
	flex-direction: column;
	border-radius: 3px;
	border: 1px solid #000 !important;
	background: rgba(217, 217, 217, 0);
	min-height: 470px;
}

.blog-post-image-container {
	width: 100%;
	height: 200px;
	border-bottom: 1px solid #d5d5d5;
}
.blog-post-title-container {
	width: 100%;
	height: auto;
}
.blog-post-title-description {
	width: 100%;
	min-height: 100px;
}
.blog-post-read-details-action {
	width: 100%;
	min-height: 70px;
}

.blog-inner-container {
	width: 300px;
}

.blog-post-title {
	width: 100%;
	height: 80px;
	font-size: 16px;
	font-weight: 400;
	text-align: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin: 0 !important;
}

.blog-post-date {
	width: 100%;
	height: 50px;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
}

.blog-title-text {
	width: 100%;
	height: 100%;
	color: #272727;
	text-align: center;
	font-family: GeomGraphic;
	font-size: 18px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
}

.blog-text {
	color: #272727;
	text-align: center;
	font-family: Rajdhani;
	font-size: 18px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
}

.blog-post-image {
	width: 100%;
	height: 100%;
}

.blog-post-backgroundImage {
	/* padding-inline: 20px; */
	/* padding-block: 5px; */
	/* border-top-right-radius: 0em; */
	/* border-top-left-radius: 0em; */
	/* width: auto; */
	width: 100%;
	height: 100%;
	background-position: center center;
	background-size: 100% 100%;
}

.cover {
	width: 100%;
	/* height: 126px; */
	height: 100%;
	object-fit: cover;
	border-radius: 0;
	aspect-ratio: 16/9;
}

.blog-post-info {
	font-size: 16px !important;
	font-weight: 400 !important;
	height: 100px;
	width: 100%;
	text-align: center;
	padding: 15px 20px;
	line-height: normal;
	font-family: "Rajdhani";
}

.blog-post-info p {
	margin-top: 15px;
	margin-bottom: 0px !important;
}

.blog-info-meta {
	font-size: 14px;
	color: gray;
	padding-block: 15px;
}

.blog-read-more {
	display: inline-block;
	margin-top: 12px;
	font-size: 16px;
	color: var(--primary-color);
	text-decoration: none;
	transition: color 0.3s ease;
	bottom: 46px !important;
}

.blog-item:hover .blog-read-more {
	color: var(--black-color);
}

.blog-read-more i {
	transition: transform 0.3s ease;
}

.blog-read-more:hover i {
	transform: translateX(5px);
}

.blog-item:hover .blog-post-image::after {
	width: 100%;
	left: 0;
	right: auto;
}

.blog-item:hover .blog-post-image .blog-post-backgroundImage {
	width: 100%;
	-webkit-transform: scale3d(1.2, 1.2, 1.2);
	transform: scale3d(1.2, 1.2, 1.2);
}

.blog-post-image .blog-post-backgroundImage {
	-webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
	-o-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
	transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
	border-top-right-radius: 0em;
	border-top-left-radius: 0;
}

p {
	font-family: Rajdhani;
    font-size: 16px;
    font-style: normal;
    line-height: 20px;
	font-weight: 400;

}
</style>
